export const PRACTICE_NAME =
  'Privatpraxis für Psychiatrie und Psychotherapie Maliha Malik';

export const PRACTICE_DESCRIPTION =
  'Privatpraxis für Psychiatrie und Psychotherapie von Fachärztin Maliha Malik in Hamburg-Bergedorf. Individuelle Beratung, medikamentöse Behandlung und tiefenpsychologisch fundierte Psychotherapie mit transkulturellem Schwerpunkt.';

export const PRACTICE_KEYWORDS = [
  'Psychiatrie Bergedorf',
  'Psychotherapie Bergedorf',
  'Privatpraxis Hamburg',
  'Maliha Malik',
  'Burnout Behandlung',
  'Depression',
  'Trauma',
  'Transkulturelle Psychiatrie',
  'Videosprechstunde',
];

export const PRACTICE_IMAGE = '/praxis.jpeg';

export const PRACTICE_STRUCTURED_DATA = {
  '@context': 'https://schema.org',
  '@type': 'MedicalClinic',
  name: PRACTICE_NAME,
  description: PRACTICE_DESCRIPTION,
  image: PRACTICE_IMAGE,
  medicalSpecialty: ['Psychiatry', 'Psychotherapy'],
  email: 'malik@psychiater-bergedorf.de',
  telephone: '+49 40 60053458',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Sachsentor 26',
    addressLocality: 'Hamburg',
    addressRegion: 'Hamburg',
    postalCode: '21029',
    addressCountry: 'DE',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 53.48774,
    longitude: 10.21303,
  },
  url: '',
};
